import { createFileRoute, redirect } from "@tanstack/react-router";

import { LegacyStaffForm } from "@/components/staff/LegacyStaffForm";
import { env } from "@/config/env";

/**
 * The old Add Staff screen. While the People Hub is switched off this is the
 * live page; once it's on, Add Employee under /people takes over and old links
 * still land.
 */
export const Route = createFileRoute("/_authenticated/settings/staff/new")({
  beforeLoad: () => {
    if (env.VITE_PEOPLE_HUB_ENABLED) {
      throw redirect({ to: "/people/new" });
    }
  },
  component: AddStaffPage,
});

function AddStaffPage() {
  return <LegacyStaffForm mode="create" />;
}
